import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import Link from '@mui/material/Link';

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: ({ depthLevel }) => theme.spacing((depthLevel + 1) * 4),
  },
}));

const MenuItem = ({ to, label, icon, closeMenu, external, depthLevel }) => {
  const classes = useStyles({ depthLevel });
  const navigate = useNavigate();
  const location = useLocation()

  const isActive =
    to === '/' ? location.pathname === to : location.pathname.includes(to);

  const handleClick = () => {
    closeMenu();

    if (!external) {
      navigate(to);
    }
  };

  const renderListItem = () => (
    <ListItem className={classes.nested} onClick={handleClick} selected={isActive} button>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );

  return external ? (
    <Link color="inherit" underline="none" href={to}>
      {renderListItem()}
    </Link>
  ) : (
    renderListItem()
  );
};

MenuItem.defaultProps = {
  external: false,
  depthLevel: 0,
};

MenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  closeMenu: PropTypes.func.isRequired,
  external: PropTypes.bool,
  depthLevel: PropTypes.number,
};

export default MenuItem;
